import styled from '@emotion/styled';

import Button from '@skippay/core/components/Button';
import { color } from '@skippay/core/styles/variables';

export const SButton = styled(Button)`
	background: ${color('white')};
`;
